<template>
	<div class="Modal__background" ref="Modal__background" @click="click"></div>
</template>

<script>
export default {
	data() {
		return {}
	},
	mounted() {},
	watch: {},
	methods: {
		click() {
			this.$emit('click')
		},
	},
}
</script>

<style lang="scss"></style>
